<div *ngIf="item">
	<div class="row">
		<div class="col">
			<item-publish-button
				[item]="item"
				channel="Web"
				name="Hemsida"
				republish="true"
				outdated="true"
				(change)="publishChanged($event)"
			></item-publish-button>
		</div>
		<div class="col">
			<item-publish-button
				[item]="item"
				channel="Lokalguiden"
				name="Lokalguiden"
				(change)="publishChanged($event)"
			></item-publish-button>
		</div>
		<div class="col">
			<item-publish-button
				[item]="item"
				channel="Portally"
				name="Portally"
				(change)="publishChanged($event)"
			></item-publish-button>
		</div>
		<div class="col">
			<item-publish-button
				[item]="item"
				channel="Objektvision"
				name="Objektvision"
				republish="true"
				outdated="true"
				[disabled]="isLand()"
				disabledNote="Mark kan ej publiceras"
				(change)="publishChanged($event)"
			></item-publish-button>
		</div>
		<div class="col">
			<item-publish-button
				[item]="item"
				channel="Kvadr"
				name="Kvadr"
				republish="true"
				outdated="true"
				(change)="publishChanged($event)"
			></item-publish-button>
		</div>
	</div>
</div>
